import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { MonetizationManager } from "@/features/admin/components/monetization-manager";
import { RevenueShareManager } from "@/features/admin/components/revenue-share-manager";
import { PageContainer } from "@fleet/ui";

function AdminMonetizationPage() {
  return (
    <PageContainer maxWidth="4xl">
      <MonetizationManager />
      {/* Reparto a autores (fase 2): mismo gate admin/capacidad billing. */}
      <div class="mt-10">
        <RevenueShareManager />
      </div>
    </PageContainer>
  );
}

export const adminMonetizationRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/monetization",
  component: AdminMonetizationPage,
});
